import React from 'react'
import { Modal } from 'react-bootstrap'

interface StyledModalProps {
  show: boolean
  onClose: () => void
  title?: string
  children: React.ReactNode
  bodyStyle?: React.CSSProperties
  headerClassName?: string
  bodyClassName?: string
}

const CustomModal: React.FC<StyledModalProps> = ({
  show,
  onClose,
  title,
  children,
  bodyStyle,
  headerClassName = 'border-0 px-6 pb-0',
  bodyClassName = '',
}) => {
  if (!show) return null

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton className={headerClassName}>
        {title && <Modal.Title className='fw-bold fs-1 text-gray-900'>{title}</Modal.Title>}
      </Modal.Header>
      <Modal.Body
        style={{ padding: '32px', paddingTop: '5px', paddingBottom: '20px', ...bodyStyle }}
        className={bodyClassName}
      >
        {children}
      </Modal.Body>
    </Modal>
  )
}

export default CustomModal 